import React from 'react';

const numberFormat = new Intl.NumberFormat('nl-NL');
const getValue = (option, formatType) => {
    let value = option;

    switch (formatType) {
        case 'price':
        case 'almn_lease_price':
            value = option.toLocaleString('nl-NL', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
            break;
        case 'tellerstand':
            value = numberFormat.format(option);
            break;
        case 'max_trekgewicht':
            value = `${numberFormat.format(option)} kg`;
            break;
        case 'laadtijd':
            value = option / 60;
    }

    return value;
};
export default function RangeList({ className, id, value, options, onChange, emptyValueLabel, isLoading, suffix, formatType, bounds }) {
    return (
        <select
            id={id}
            className={className}
            value={value}
            disabled={isLoading}
            onChange={({ target: { value } }) => {
                onChange(value);
            }}>
            <option value={''} disabled>
                {emptyValueLabel}
            </option>
            {options.map((option, optionIndex) => {
                return (
                    <option value={option} key={optionIndex}>
                        {getValue(option, formatType)}{suffix}
                    </option>
                );
            })}
        </select>
    );
}
